export default class NodesClassifier {
    //Public:
    constructor(cParams) {
        this.saveParams(cParams);
    }

    compute() {
        this.computeNodesLists();
        this.updateSlavesOwners();
        this.updateNodeGroups();
        this.findSlaveNumbers();
        this.findSharedNumbers();
        this.findSoloNumbers();
        this.findEachNodeLinks();
        this.findSlaveNodes();
        this.findSoloNodes();
        this.findSharedNodes();
        this.findOwnerNodes();
        this.findOwnerNumbers();
        this.findLinksNodes();
        this.updateLinkGroups();
    }

    //Private:
    saveParams(cParams) {
        this._nodes = cParams.nodes;
        this._links = cParams.links;
    }

    computeNodesLists() {
        let masterNodes = [];
        let masterIds = [];
        let nodesIds = [];
        let nodes = this._nodes;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            const isMaster = node.type === "master";
            if (isMaster) {
                masterNodes.push(node);
                masterIds.push(node.id);
            }
            nodesIds.push(node.id);
        }
        this._masterNodes = masterNodes;
        this._masterIds = masterIds;
        this._nodesIds = nodesIds;
    }

    updateSlavesOwners() {
        let masterIds = this._masterIds;
        let nodes = this._nodes;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            const isSlave = node.type === "slave";
            if (isSlave) {
                let newOwnersIds = [];
                const ownersIds = node.ownersIds;
                for (let i = 0; i < ownersIds.length; i++) {
                    const ownerId = ownersIds[i];
                    const itExists = masterIds.indexOf(ownerId) !== -1;
                    const itIsNotRepeated = newOwnersIds.indexOf(ownerId) === -1;
                    if (itExists && itIsNotRepeated) newOwnersIds.push(ownerId);
                }
                node.ownersIds = newOwnersIds;
            }
        }
    }

    updateNodeGroups() {
        this.updateMasterNodeGroups();
        this.updateSlaveNodeGroups();
    }

    updateMasterNodeGroups() {
        let maxGroup = 0;
        let masterNodes = this._masterNodes;
        for (let i = 0; i < masterNodes.length; i++) {
            const node = masterNodes[i];
            node.group = [maxGroup];
            maxGroup++;
        }
    }

    updateSlaveNodeGroups() {
        let nodes = this._nodes;
        let masterList = this._masterNodes;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            const isSlave = node.type === "slave";
            if (isSlave) {
                node.group = [];
                const ownersIds = node.ownersIds;
                ownersIds.forEach(targetId => {
                    for (let j = 0; j < masterList.length; j++) {
                        const masterNode = masterList[j];
                        if (masterNode.id === targetId) {
                            const group = masterNode.group[0];
                            node.group.push(group);
                        }
                    }
                });
            }
        }
    }

    findSlaveNumbers() {
        let masters = this._masterNodes;
        for (let i = 0; i < masters.length; i++) {
            const master = masters[i];
            let group = master.group[0];
            let slaveNumbers = this.findNumbersByGroup(group);
            master.slaveNumbers = slaveNumbers;
        }
    }

    findSharedNumbers() {
        let masters = this._masterNodes;
        for (let i = 0; i < masters.length; i++) {
            const masterA = masters[i];
            masterA.sharedNumbers = [];
            for (let j = 0; j < masters.length; j++) {
                const masterB = masters[j];
                const group = masterB.group[0];
                const itIsItself = i === j;
                if (itIsItself) {
                    masterA.sharedNumbers[group] = [];
                } else {
                    let sharedNumbers = this.findMatchingElements(masterA.slaveNumbers, masterB.slaveNumbers);
                    masterA.sharedNumbers[group] = sharedNumbers;
                }
            }
        }
    }

    findSoloNumbers() {
        let masters = this._masterNodes;
        for (let i = 0; i < masters.length; i++) {
            const master = masters[i];
            this.addAllSlaveNodesAsSolos(master);
            this.removeSharedNodesFromSolos(master);
        }
    }

    addAllSlaveNodesAsSolos(node) {
        let slaveNumbers = node.slaveNumbers;
        node.soloNumbers = [];
        for (let i = 0; i < slaveNumbers.length; i++) {
            node.soloNumbers[i] = slaveNumbers[i];
        }
    }

    removeSharedNodesFromSolos(node) {
        let slaveNumbers = node.slaveNumbers;
        let allSharedNumbers = node.sharedNumbers;
        slaveNumbers.forEach(index => {
            let hasBeenRemoved = false;
            allSharedNumbers.forEach(sharedNumbers => {
                const isNumberShared = sharedNumbers.indexOf(index) !== -1;
                if (isNumberShared && !hasBeenRemoved) {
                    let i = node.soloNumbers.indexOf(index);
                    node.soloNumbers.splice(i, 1);
                    hasBeenRemoved = true;
                }
            });
        });
    }

    findEachNodeLinks() {
        let nodes = this._nodes;
        let links = this._links;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            node.linksNumbers = [];
            for (let j = 0; j < links.length; j++) {
                const link = links[j];
                if (this.doesLinkContainNode(link, node)) {
                    node.linksNumbers.push(link.number);
                }
            }
        }
    }

    findMatchingElements(arrayA, arrayB) {
        let matchingElements = [];
        arrayA.forEach(element => {
            if (arrayB.indexOf(element) !== -1) {
                matchingElements.push(element);
            }
        });
        return matchingElements;
    }

    findNumbersByGroup(group) {
        let matchingNodes = [];
        let nodes = this._nodes;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            const isSlave = node.type === "slave";
            const belongsToGroup = node.group.indexOf(group) !== -1;
            if (isSlave && belongsToGroup) {
                const number = node.number;
                matchingNodes.push(number);
            }
        }
        return matchingNodes;
    }

    doesLinkContainNode(link, node) {
        let itIsSource = link.sourceId === node.id;
        let itIsTarget = link.targetId === node.id;
        if (itIsSource || itIsTarget) return true;
        else return false;
    }

    findOwnerNodes() {
        let masterIds = this._masterIds;
        let masterNodes = this._masterNodes;
        let nodes = this._nodes;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            let ownersNodes = [];
            let ids = node.ownersIds;
            ids.forEach(id => {
                let index = masterIds.indexOf(id);
                let ownerNode = masterNodes[index];
                ownersNodes.push(ownerNode);
            });
            node.ownersNodes = ownersNodes;
        }
    }

    findSlaveNodes() {
        let nodes = this._nodes;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            let numbers = node.slaveNumbers;
            if (numbers !== undefined) {
                let slaveNodes = this.findNodesByNumbers(numbers);
                node.slaveNodes = slaveNodes;
            }
        }
    }

    findSoloNodes() {
        let nodes = this._nodes;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            if (node.type === "master") {
                let numbers = node.soloNumbers;
                if (numbers !== undefined) {
                    let soloNodes = this.findNodesByNumbers(numbers);
                    node.soloNodes = soloNodes;
                }
            }
        }
    }

    findSharedNodes() {
        let nodes = this._nodes;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            if (node.type === "master") {
                let allSharedNumbers = node.sharedNumbers;
                let allSharedNodes = [];
                allSharedNumbers.forEach(numbers => {
                    if (numbers !== undefined) {
                        let sharedNodes = this.findNodesByNumbers(numbers);
                        allSharedNodes.push(sharedNodes);
                    }
                });
                node.sharedNodes = allSharedNodes;
            }
        }
    }

    findNodesByNumbers(numbers) {
        let validNodes = [];
        let allNodes = this._nodes;
        for (let i = 0; i < allNodes.length; i++) {
            const node = allNodes[i];
            let number = node.number;
            let isNumberInList = numbers.indexOf(number) !== -1;
            if (isNumberInList) validNodes.push(node);
        }
        return validNodes;
    }

    findOwnerNumbers() {
        let nodes = this._nodes;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            let ownersNumbers = [];
            let ownersNodes = node.ownersNodes;
            ownersNodes.forEach(ownerNode => {
                let number = ownerNode.number;
                ownersNumbers.push(number);
            });
            node.ownersNumbers = ownersNumbers;
        }
    }

    findLinksNodes() {
        let links = this._links;
        links.forEach(link => {
            const sourceId = link.sourceId;
            const targetId = link.targetId;
            const source = this.findNodeById(sourceId);
            const target = this.findNodeById(targetId);
            link.source = source;
            link.target = target;
        });
    }

    updateLinkGroups() {
        let links = this._links;
        links.forEach(link => {
            const source = link.source;
            const group = source.group[0];
            link.group = group;
        });
    }

    findNodeById(id) {
        const nodes = this._nodes;
        const nodesIds = this._nodesIds;
        const index = nodesIds.indexOf(id);
        const node = nodes[index];
        return node;
    }
}
